export const locale = {
    lang: 'es',
    data: {
      'NOTIFICACIONES': {
        'INFO': {
          'HOY': 'Hoy',
          'TITUNOT': 'Notificaciones',
          'NOTTTIP': 'Marcar como leído'
        },
        'EDITOR_EMAILS': {
          'NUEVAMOD': 'La empresa <b>-ALVPRRO-</b> ha realizado una modificación a uno o más de sus correos electrónicos de comunicación',
          'NUEVAMODODS': 'Un jefe de proyecto ha realizado cambios a uno o más correos electrónicos de comunicación de la empresa <b>-ALVPRRO-</b>'
        },
        'AUTORI-ENCUESTA': {
          'AUTORIZAR-ENCUESTA': 'La empresa <b>-ALVPRRO-</b> a mandado a autorizar la encuesta',
        },
      },
      'NOTIFICACION_PRODUCT':{
      'PRODUCTOS_ID':{
        '20':'Certificar',
        '40':'Certificar 3.0',
        '41':'Medir 3.0',
        '42':'Pulsecheck 3.0',
        '43':'Focus Area ',
        '53':'Líder Go',
        '54':'Action Go',
        '56':'AMCO',
        '57':'Trabajo digno',
        '58':'Primer Empleo',
        '63':'NOM-035 v3.0',
      },
      'TIPO_MENSAJE_MOSTRAR':{
        'languageNative':'Has seleccionado el idioma principal',
        'sinAdicionales':'Has seleccionado sin idiomas adicionales',
        'languageAdittional':'Has seleccionado los idiomas adicionales',
        'conAdicionales':'Has deseleccionado el check sin idiomas adicionales ',
        'deleteLangNative':'Has eliminado el idioma nativo',
        'completePasLang': 'Has completado el paso de idiomas',
        'completePasTemplate': 'Has completado el paso de plantilla',
        'completePasReacti': 'Has completado el paso de reactivos',
        'completePasNps': 'Has completado el paso de nps',
        'completePasControl': 'Has completado el paso de control',
        'completePasDemogra': 'Has completado el paso de demograficos',
        'completePasAbierta': 'Has completado el paso de abiertas',
        'completePasAdicio': 'Has completado el paso de adicionales',
        'completePas4all': 'Has completado el paso de forall',
        'completePasEncues': 'Has completado el paso de encuesta',
        'completePasColab': 'Has completado el paso de colaboradores',
        'completePasEnvi': 'Has completado el paso de envio',
        'completePasEstat': 'Has completado el paso de estatus de encuesta',
        'completePasProgra': 'Has completado el paso de programación',
        'DescompletePasLang': 'Has descompletado el paso de idiomas',
        'DescompletePasTemplate': 'Has descompletado el paso de plantilla',
        'DescompletePasReacti': 'Has descompletado el paso de reactivos',
        'DescompletePasNps': 'Has descompletado el paso de nps',
        'DescompletePasControl': 'Has descompletado el paso de control',
        'DescompletePasDemogra': 'Has descompletado el paso de demograficos',
        'DescompletePasAbierta': 'Has descompletado el paso de abiertas',
        'DescompletePasAdicio': 'Has descompletado el paso de adicionales',
        'DescompletePas4all': 'Has descompletado el paso de forall',
        'DescompletePasEncues': 'Has descompletado el paso de encuesta',
        'DescompletePasColab': 'Has descompletado el paso de colaboradores',
        'DescompletePasEnvi': 'Has descompletado el paso de envio',
        'DescompletePasEstat': 'Has descompletado el paso de estatus de encuesta',
        'DescompletePasProgra': 'Has descompletado el paso de programación',
        'createSurvey': 'Se ha creado la encuesta',
        'saveUserDemo': 'Se han guardado los usuarios demo a la encuesta',
        'recreateSurvey': 'Se ha recreado la encuesta',
        'saveSeccionNps': 'Se ha guardado la sección nps a la encuesta',
        'saveSeccionReactivos': 'Se ha guardado la sección reactivos a la encuesta',
        'saveSeccionControl': 'Se ha guardado la sección control a la encuesta',
        'saveSeccionDemogra': 'Se ha guardado la sección demograficos a la encuesta',
        'saveSeccionAbier': 'Se ha guardado la sección abiertas a la encuesta',
        'saveSeccionForall': 'Se ha guardado la sección forall a la encuesta',
        'saveSeccionAdicio': 'Se ha guardado la sección adicionales a la encuesta',
        'subBaseColab': 'Se ha subido la base de colaboradores',
        'downloadBaseColab': 'Se ha descargado la base de colaboradores',
        'deleteBaseColab': 'Se ha eliminado la base de colaboradores',
        'saveUsersSurvey': 'Se han guardado los colaboradores a la encuesta',
        'regisFechaLanza': 'Se ha registrado la fecha de lanzamiento de la encuesta',
        'regisFechaAviso1': 'Se ha registrado la fecha de aviso 1 previo a la encuesta',
        'regisFechaAviso2': 'Se ha registrado la fecha de aviso 2 previo a la encuesta',
        'saveRecordatorioEncu': 'Se ha registrado un recordatorio',
        'enviarCorreos': 'Se ha seleccionado enviar el correo a sus colaboradores',
        'noEnviarCorreos': 'Se ha seleccionado no enviar el correo a sus colaboradores',
        'cambiarEstatusCorreo': 'Se ha realizado el cambio  para modificar el envio de correo',
        'ActivaEstatEncu': 'Se ha activado la encuesta',
        'DesacEstatEncu': 'Se ha desactivado la encuesta',
        'activoSeccionNps':'Se ha activado la sección NPS para la encuesta',
        'desActivoSeccionNps':'Se ha desactivado la sección NPS para la encuesta',
        'activoSeccionReactivos':'Se ha activado la sección REACTIVOS para la encuesta',
        'desActivoSeccionReactivos':'Se ha desactivado la sección REACTIVOS para la encuesta',
        'activoSeccionControl':'Se ha activado la sección CONTROL para la encuesta',
        'desActivoSeccionControl':'Se ha desactivado la sección CONTROL para la encuesta',
        'activoSeccionDemograficos':'Se ha activado la sección DEMOGRAFICOS para la encuesta',
        'desActivoSeccionDemograficos':'Se ha desactivado la sección DEMOGRAFICOS para la encuesta',
        'activoSeccionAbiertas':'Se ha activado la sección ABIERTAS para la encuesta',
        'desActivoSeccionAbiertas':'Se ha desactivado la sección ABIERTAS para la encuesta',
        'activoSeccionForall':'Se ha activado la sección FORALL para la encuesta',
        'desActivoSeccionForall':'Se ha desactivado la sección FORALL para la encuesta',
        'activoSeccionAdicionales':'Se ha activado la sección ADICIONALES para la encuesta',
        'desActivoSeccionAdicionales':'Se ha desactivado la sección ADICIONALES para la encuesta',
        'deletePregTemNps':'Se ha eliminado la pregunta de la sección NPS',
        'deletePregTemReacti':'Se ha eliminado la pregunta de la sección REACTIVOS',
        'deletePregTemControl':'Se ha eliminado la pregunta de la sección CONTROL',
        'deletePregTemDemogra':'Se ha eliminado la pregunta de la sección DEMOGRAFICOS',
        'deletePregTemAbier':'Se ha eliminado la pregunta de la sección ABIERTAS',
        'deletePregTemAdici':'Se ha eliminado la pregunta de la sección ADICIONALES',
        'savePregCatNps':'Se ha guardado la pregunta de catalago a la sección NPS',
        'savePregCatReacti':'Se ha guardado la pregunta de catalago a la sección REACTIVOS',
        'savePregCatControl':'Se ha guardado la pregunta de catalago a la sección CONTROL',
        'savePregCatDemogra':'Se ha guardado la pregunta de catalago a la sección DEMOGRAFICOS',
        'savePregCatAbier':'Se ha guardado la pregunta de catalago a la sección ABIERTAS',
        'savePregCatAdici':'Se ha guardado la pregunta de catalago a la sección ADICIONALES',
        'savePregNueNps':'Se ha guardado la pregunta nueva a la sección NPS',
        'savePregNueReacti':'Se ha guardado la pregunta nueva a la sección REACTIVOS',
        'savePregNueControl':'Se ha guardado la pregunta nueva a la sección CONTROL',
        'savePregNueDemogra':'Se ha guardado la pregunta nueva a la sección DEMOGRAFICOS',
        'savePregNueAbier':'Se ha guardado la pregunta nueva a la sección ABIERTAS',
        'savePregNueAdici':'Se ha guardado la pregunta nueva a la sección ADICIONALES',
        'editPregNps':'Se ha editado la pregunta de la sección NPS',
        'editPregReacti':'Se ha editado la pregunta de la sección REACTIVOS',
        'editPregControl':'Se ha editado la pregunta de la sección CONTROL',
        'editPregDemogra':'Se ha editado la pregunta de la sección DEMOGRAFICOS',
        'editPregAbier':'Se ha editado la pregunta de la sección ABIERTAS',
        'editPregAdici':'Se ha editado la pregunta de la sección ADICIONALES',
        'LogOut':'Ha cerrado sesión ',
        'reiniciarLang':'Ha reiniciado el producto',
        'accionText':'',
        'updatCuesForall':'Se ha actualizado el cuestionario de la sección forall',
        'savePracticaForall':'Se ha guardado la practica forall',
        'saveDescripForall':'Se ha guardado la descripción de la practica forall',
        '':'',
      },
      'BTN_MOSTRAR_HISTO':'Mostrar historial',
      'ETI_PRODUC':'Producto:',
      'TITLE_HISTO_PROD':'Historial productos',
      'CARG_INFOR':'Cargando información',
      'TITLE_FILTER':'Filtrar: ',
      'DELETE_FILTER':'Borrar filtros',
      'FILTER_1':'Fecha:',
      'BUSCAR_FILTER':'Buscar',
      'TH_TITTLE':'Historial producto',
      'BTN_FILTER_HISTO':'Filtrar historial',
      'TD_USUARIO':'Usuario:',
      'TD_FECHA_PRODU':'Fecha producto:',
      'TD_TIPO_PRODU':'Tipo producto:',
      'TD_TIPO_USU_ADMI':'Usuario administrador',
      'WARNING_NO_DATOS':'Sin información por mostrar',

      }
    }
};
